import { createUseStyles } from 'react-jss';

export const styles = createUseStyles({
  inspectorContainer: {},
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inspectorColorPicker: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  inspectorColorPickerInner: {
    gap: 2,
    cursor: 'pointer',
  },
  colorPickerPreview: {
    width: 50,
    height: 16,
  },
  inspectorInput: {
    position: 'relative',
    '& input': {
      maxWidth: 26,
      outline: 'none',
      border: 'none',
      marginRight: 10,
      color: '#525251',
      fontWeight: 700,
      fontSize: 11,
    },
    '& span': {
      position: 'absolute',
      right: 3,
      userSelect: 'none',
      color: '#c2c1c1',
    },
  },
  inspectorDashType: {},
  inspectorDashTypeContainer: {
    cursor: 'pointer',
    '& img': {
      width: 20,
      height: 20,
      filter: 'invert(58%) sepia(6%) saturate(18%) hue-rotate(2deg) brightness(92%) contrast(87%)',
    },
    '& span': {
      color: '#525251',
      padding: '2.5px 5px',
      overflow: 'hidden',
      userSelect: 'none',
      whiteSpace: 'nowrap',
      fontSize: 11,
      textOverflow: 'ellipsis',
      fontWeight: 600,
    },
  },
  border: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #b8b8b8',
    borderRadius: 2,
    padding: 3,
    background: '#fff',
    maxHeight: 24,
    height: 24,
  },
  dropdown: {
    '& .ant-dropdown-menu': {
      padding: '0!important',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: '0 1px 1px #0000001a',
    },
    '& .ant-dropdown-menu-item': {
      padding: '0px!important',
      '& span': {
        padding: '4px 8px',
        fontSize: 11,
        display: 'block',
        whiteSpace: 'nowrap',
        color: '#525251',
        fontWeight: 600,
      },
    },
    '& .ant-dropdown-menu-item:hover': {
      '& span': {
        backgroundColor: '#006CE5',
        color: '#fff',
      },
    },
    '& .ant-dropdown-menu-title-content': {
      padding: '0!important',
    },
  },
  inspectorDirection: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  directionIcon: {
    cursor: 'pointer',
    padding: '6px 8px',
    backgroundColor: '#f5f5f5',
    '& svg': {
      width: 14,
      height: 14,
    },
    '&.selected': {
      backgroundColor: '#fff',
      '& svg': {
        color: '#006CE5!important',
      },
    },
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  inspectorTicks: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    marginRight: 14.5,
    '& span': {
      fontSize: 11,
      cursor: 'pointer',
      color: '#525251',
      fontWeight: 600,
      backgroundColor: '#f5f5f5',
      userSelect: 'none',
      '&.selected': {
        color: '#006CE5',
        backgroundColor: '#fff',
      },
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
  },
});
